import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AndromedaButtonComponent, NavigationPath } from '@upassignations/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'lib-unauthorised',
  imports: [AndromedaButtonComponent, CommonModule],
  templateUrl: './unauthorised.component.html',
  styleUrl: './unauthorised.component.scss',
})
export class UnauthorisedComponent implements OnInit {
  loaded = false;

  // eslint-disable-next-line no-unused-vars
  constructor(private router: Router, private cookieService: CookieService) {}

  ngOnInit(): any {
    this.clearSessionData();

    //enable css to load first to prevent lagging flicker behaviour in browser rendering
    setTimeout(() => {
      this.loaded = true;
    }, 50);
  }

  clearSessionData(): void {
    localStorage.removeItem('apiToken');
    this.cookieService.deleteAll('/');
  }

  redirectToHome(): any {
    this.router.navigate([NavigationPath.Home]);
  }
}
